import type { oz } from '@weft/utils';
import { NewProductVariantSchema } from '../../new-product-variant-schema';
import { CommercialTermsPricingSchema } from './commercial-terms-pricing-schema';

export const NewCommercialTermsVariantSchema = NewProductVariantSchema
  .extend({ pricing: CommercialTermsPricingSchema })
  .openapi('NewCommercialTermsVariant');

export type NewCommercialTermsVariant = oz.infer<typeof NewCommercialTermsVariantSchema>;